export enum FilterType{
    CodeName = 1,
    Name = 2,
    ItemId = 3,
    SmallName = 4,
    Number = 5,
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/filter-type.ts